import Vue from "vue";

import VueCurrencyFilter from 'vue-currency-filter';
import moment from 'moment-mini'

Vue.use(VueCurrencyFilter,
 {
  symbol: '£',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: false
 });

/**
 * Vue filter to convert the given datetime
 *
 * @param {String} value    The value string.
 * @param {Number} decimals The number of decimal places.
 */
Vue.filter('formatDateTime', function (value) {
 if (value) {
  let check_if_just_date = /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}?$/;
  let passed_value = value;
  if (check_if_just_date.test(passed_value)) {
   return moment.utc(String(passed_value)).add(2, 'hours').format('DD/MM/YYYY [at] HH:mm')
  } else {
   return moment.utc(String(passed_value)).format('DD/MM/YYYY [at] HH:mm')
  }
 }
});
Vue.filter('formatDateTimeYMD', function (value) {
 if (value) {
  let check_if_just_date = /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}?$/;
  let passed_value = value;
  if (check_if_just_date.test(passed_value)) {
   return moment.utc(String(passed_value)).add(2, 'hours').format('YYYY-MM-DD [at] HH:mm')
  } else {
   return moment.utc(String(passed_value)).format('YYYY-MM-DD [at] HH:mm')
  }
 }
});

Vue.filter('formatDate', function (value) {
 if (value) {
  let check_if_just_date = /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}?$/;
  let passed_value = value;
  if (check_if_just_date.test(passed_value)) {
   return moment.utc(String(passed_value)).add(2, 'hours').format('DD/MM/YYYY')
  } else {
   return moment.utc(String(passed_value)).format('DD/MM/YYYY')
  }
 }
});
Vue.filter('formatDateYMD', function (value) {
 if (value) {
  let check_if_just_date = /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}?$/;
  let passed_value = value;
  if (check_if_just_date.test(passed_value)) {
   return moment.utc(String(passed_value)).add(2, 'hours').format('YYYY-MM-DD')
  } else {
   return moment.utc(String(passed_value)).format('YYYY-MM-DD')
  }
 }
});
Vue.filter('format_ts_period_date', function (value) {
 if (value) {
  let check_if_just_date = /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}?$/;
  let passed_value = value;
  if (check_if_just_date.test(passed_value)) {
   return moment.utc(String(passed_value)).add(2, 'hours').format('Do MMMM YYYY')
  } else {
   return moment.utc(String(passed_value)).format('Do MMMM YYYY')
  }
 }
});
Vue.filter('format_ts_period_date_plus_day', function (value) {
 if (value) {
  let check_if_just_date = /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}?$/;
  let passed_value = value;
  if (check_if_just_date.test(passed_value)) {
   return moment.utc(String(passed_value)).add(2, 'hours').format('ddd Do MMMM YYYY')
  } else {
   return moment.utc(String(passed_value)).format('ddd Do MMMM YYYY')
  }
 }
});

Vue.filter('formatHourMinTime', function (value) {
 if (value) {
  const parts = value.split(":");
  return parts[0] + ":" + parts[1];
 }
 else {
  return "unknown"
 }
});

Vue.filter('filter_tags', function (value) {
 let filteredValue = value.replace(/<\/?[^>]+(>|$)/g, '');
 return filteredValue.replaceAll('&nbsp;', ' ');
});
Vue.filter('csv', function (value) {
 let arrValue = value.map(function (elem) {
  return elem.emailAddress.address;
 });
 return arrValue.join(', ');
});
Vue.filter('time', function (value, is24HrFormat = false) {
 if (value) {
  const date = new Date(Date.parse(value));
  let hours = date.getHours();
  const min = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes()
  if (!is24HrFormat) {
   const time = hours > 12 ? 'AM' : 'PM';
   hours = hours % 12 || 12;
   return `${hours}:${min} ${time}`
  }
  return `${hours}:${min}`
 }
});

/**
 * Vue filter to convert the given value to 2 decimal places.
 *
 * @param {String} value    The value string.
 * @param {Number} digits The number of decimal places.
 */
Vue.filter('decimal2', function (value, digits) {
    return value.toFixed(2);
});

/**
 * Vue filter to convert the given value to percent.
 *
 * @param {String} value    The value string.
 * @param {Number} digits The number of decimal places.
 */
Vue.filter('percentage', function (value, digits) {
 let result;
 if (digits === null || digits === undefined) {
  digits = 2;
 }
 digits = parseInt(digits);
 if (value === null || value === '' || isNaN(value)) {
  result = '-';
 }
 else {
  result = Math.round(value * Math.pow(10, digits)) / Math.pow(10, digits) + '%';
 }
 return result;
});

/**
 * Vue filter to capitalise all words
 */
Vue.filter('camel', function (str) {
 return str.toLowerCase().replace(/^\w|\s\w/g, function (letter) {
  return letter.toUpperCase();
 })
});

/**
 * Return capitalised first letter of log type
 */
Vue.filter('capitalLogType', function (str) {
 return str.charAt(0).toUpperCase();
});

/**
 * Return all words capitalised
 */
Vue.filter('capitalWords', function (str) {
 return str.toLowerCase().replace(/^[\u00C0-\u1FFF\u2C00-\uD7FF\w]|\s[\u00C0-\u1FFF\u2C00-\uD7FF\w]/g, function (letter) {
  return letter.toUpperCase();
 });
});

/**
 * Nice value of what worker model log was made on
 */
Vue.filter('workerModelLog', function (str) {
 let model;
 switch (str) {
  case 'App\\Models\\Workers\\Worker':
   model = 'Worker';
   break;
  case 'App\\Models\\Workers\\WorkerBank':
   model = 'Bank';
   break;
  case 'App\\Models\\Workers\\WorkerCompanyInfo':
   model = 'Company/Status';
   break;
  case 'App\\Models\\Workers\\WorkerComplianceTests':
   model = 'Entity Test';
   break;
  case 'App\\Models\\Workers\\WorkerProfile':
   model = 'Profile';
   break;
  case 'App\\Models\\Workers\\WorkerRecruitmentInfo':
   model = 'Recruitment Info';
   break;
  case 'App\\Models\\Workers\\WorkerServices':
   model = 'Services';
   break;
 }
 return model;
});

/**
 * Nice value of what client model log was made on
 */
Vue.filter('clientModelLog', function (str) {
 let model;
 switch (str) {
  case 'App\\Models\\Clients\\ClientAccountsInfo':
   model = 'Accounts Info';
   break;
  case 'App\\Models\\Clients\\ClientAddresses':
   model = 'Address';
   break;
  case 'App\\Models\\Clients\\ClientContracts':
   model = 'Contract';
   break;
  case 'App\\Models\\Clients\\ClientPreAgreement':
   model = 'Pre Agreement';
   break;
  case 'App\\Models\\Clients\\ClientFiles':
   model = 'Files';
   break;
  case 'App\\Models\\Clients\\ClientNotes':
   model = 'Note';
   break;
  case 'App\\Models\\Clients\\Clients':
   model = 'Record';
   break;
  case 'App\\Models\\Clients\\ClientReferrals':
   model = 'Referrals';
   break;
 }
 return model;
});

/**
 * Nice value of what contact model log was made on
 */
Vue.filter('contactModelLog', function (str) {
 let model;
 switch (str) {
  case 'App\\Models\\Contacts\\ContactNotes':
   model = 'Note';
   break;
  case 'App\\Models\\Contacts\\Contacts':
   model = 'Profile';
   break;
 }
 return model;
});

Vue.filter('modelLog', function (str) {
 let model;
 switch (str) {
  // Companies / Contacts
  case 'App\\Models\\Companies\\Contacts\\Contact':
   model = 'Contact';
   break;
  case 'App\\Models\\Companies\\Contacts\\ContactProfile':
   model = 'Contact Profile';
   break;
  case 'App\\Models\\Companies\\Contracts\\CompanyContracts':
   model = 'Company Contract';
   break;
  case 'App\\Models\\Companies\\Health_check\\CompanyHealthCheck':
   model = 'Company Health Check';
   break;
  case 'App\\Models\\Companies\\Pre_Agreement\\CompanyPreAgreement':
   model = 'Company Pre Agreement';
   break;
  case 'App\\Models\\Companies\\Company':
   model = 'Company';
   break;
  case 'App\\Models\\Companies\\CompanyBank':
   model = 'Company Bank';
   break;
  case 'App\\Models\\Companies\\CompanyCreditFinance':
   model = 'Company Credit/Finance';
   break;
  case 'App\\Models\\Companies\\CompanyPayGroups':
   model = 'Company Pay Groups';
   break;
  case 'App\\Models\\Companies\\CompanyPaymentProcessInfo':
   model = 'Company Payment/Process Info';
   break;
  case 'App\\Models\\Companies\\CompanyProfile':
   model = 'Company Profile';
   break;
  case 'App\\Models\\Companies\\CompanyReferralRebate':
   model = 'Company Referral/Rebate';
   break;
  case 'App\\Models\\Companies\\CompanyRelationship':
   model = 'Company Relationship';
   break;
  case 'App\\Models\\Companies\\CompanyServices':
   model = 'Company Services';
   break;
  // Contact Info
  case 'App\\Models\\Contact_Info\\Address':
   model = 'Address';
   break;
  case 'App\\Models\\Contact_Info\\Email':
   model = 'Email';
   break;
  case 'App\\Models\\Contact_Info\\Phone':
   model = 'Phone';
   break;
  // Files
  case 'App\\Models\\Files\\Avatar':
   model = 'Avatar';
   break;
  case 'App\\Models\\Files\\File':
   model = 'File';
   break;
  // Notes
  case 'App\\Models\\Notes\\Note':
   model = 'Note';
   break;
  // Orders
  // People
  case 'App\\Models\\People\\Person':
   model = 'Person';
   break;
  case 'App\\Models\\People\\PersonRelationship':
   model = 'Person Relationship';
   break;
  // Records
  case 'App\\Models\\Records\\Records':
   model = 'Record';
   break;
  // Workers
  case 'App\\Models\\Workers\\Tax\\TaxExpenses':
   model = 'Tax Expenses';
   break;
  case 'App\\Models\\Workers\\Tax\\TaxGenius':
   model = 'Genius Tax';
   break;
  case 'App\\Models\\Workers\\Tax\\TaxMileage':
   model = 'Tax Mileage';
   break;
  case 'App\\Models\\Workers\\Tax\\TaxReturns':
   model = 'Tax Returns';
   break;
  case 'App\\Models\\Workers\\Worker':
   model = 'Worker';
   break;
  case 'App\\Models\\Workers\\WorkerBanks':
   model = 'Worker Bank';
   break;
  case 'App\\Models\\Workers\\WorkerCompanyInfo':
   model = 'Worker Company Info';
   break;
  case 'App\\Models\\Workers\\WorkerComplianceTests':
   model = 'Worker Compliance Tests';
   break;
  case 'App\\Models\\Workers\\WorkerProfile':
   model = 'Worker Profile';
   break;
  case 'App\\Models\\Workers\\WorkerRecruitmentInfo':
   model = 'Worker Recruitment Info';
   break;
  case 'App\\Models\\Workers\\WorkerServices':
   model = 'Worker Services';
   break;
 }
 return model;
});
